import { getAddress } from "ethers/lib/utils";
import { KudosContributor } from "../../@types/KudosContributor";
import {
  getKudosContributors,
  getKudosOwners,
} from "../../services/apis/KudosApi/KudosDetails";

export const isUserAllowlisted = async (tokenId: string, user: any) => {
  const userAddresses =
    user.addresses?.map((address: any) =>
      address.address !== "" ? getAddress(address.address) : "",
    ) ?? [];

  const userDiscordIds =
    (user.discordAccounts?.length &&
      user.discordAccounts?.map((account: any) => account.discordUserId)) ??
    [];

  // check addresses
  for (let i = 0; i < userAddresses.length; i++) {
    const response = await getKudosContributors(
      tokenId,
      0,
      undefined,
      userAddresses[i],
    );
    if (response.data.length > 0) {
      return true;
    }
  }

  // then check discord
  for (let i = 0; i < userDiscordIds.length; i++) {
    const response = await getKudosContributors(
      tokenId,
      0,
      undefined,
      userDiscordIds[i],
    );
    if (response.data.length > 0) {
      return true;
    }
  }
  return false;
};

export const doesUserAlreadyOwnToken = async (
  tokenId: string,
  walletAddress: string,
) => {
  const response = await getKudosOwners(tokenId, 0, undefined, walletAddress);
  return response.data.length > 0;
};

export const isDiscordKudos = (
  contributors: KudosContributor[] | undefined,
) => {
  if (!contributors) {
    return false;
  }

  return (
    contributors?.filter((contributor) => {
      return contributor.accountType === "discord";
    })?.length > 0 ?? false
  );
};
